import React, {Component} from 'react'
import {observer} from 'mobx-react'
import RadioQuestion from '../Question/RadioQuestion'
import MultipleQuestion from '../Question/MultipleQuestion'
import BlankQuestion from '../Question/BlankQuestion'
import SpeakingQuestion from '../Question/SpeakingQuestion'
import WritingQuestion from  '../Question/WritingQuestion'
import styles from './index.css'

@observer(['practiceStore'])
export default class Questions extends Component {
  renderQuestion() {
    const { practiceStore } = this.props
    const detail = practiceStore.detail ? practiceStore.detail : []

    let questions = detail.map((item, index) => {
      switch (item.category) {
        case 'radio':
          return (
            <RadioQuestion
              key={ index }
              questionIndex={ index }
              { ...item }
            />
          )
        case 'multi':
          return (
            <MultipleQuestion
              key={ index }
              questionIndex={ index }
              {...item}
            />
          )
        case 'blank':
          return (
            <BlankQuestion
              key={ index }
              isSingleLayout={practiceStore.isSingleLayout}
              questionIndex={ index }
              {...item}
            />
          )
        case 'speaking':
          return (
            <SpeakingQuestion
              key={ index }
              stem={ item.question }
              analysisAnswer={ item.answer_analysis }
              answerTime={ practiceStore.answerTime }
              questionIndex={ index }
              {...item}
            />
          )
        case 'writing':
          return (
            <WritingQuestion
              key={ index }
              textLimit={practiceStore.textLimit}
              questionIndex={ index }
              {...item}
            />
          )
        default:
          return null
      }
    })
    return questions
  }

  render() {
    return (
      <div className={styles.questionBox}>{ this.renderQuestion() }</div>
    )
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Main/Questions.js
 **/